import { render } from "./AddResultModel.vue?vue&type=template&id=217e3882&scoped=true"
import script from "./AddResultModel.vue?vue&type=script&lang=js"
export * from "./AddResultModel.vue?vue&type=script&lang=js"

import "./AddResultModel.vue?vue&type=style&index=0&id=217e3882&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-217e3882"]])

export default __exports__